import { useState, useEffect, useCallback } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MultiImageUpload from "../../shared/MultiImageUpload/index.tsx";
import { request } from "../../config/request.ts";
import { toast } from "react-toastify";

interface WashImageDialogProps {
  open: boolean;
  onClose: () => void;
  washId: number;
}

export default function WashImageDialog({
  open,
  onClose,
  washId,
}: WashImageDialogProps) {
  const [existingImages, setExistingImages] = useState<any[]>([]);

  useEffect(() => {
    if (open && washId) {
      setExistingImages([]);
      fetchImages();
    }
  }, [open, washId]);

  const fetchImages = async () => {
    try {
      const res = await request.get("/api/getWashImages", { washId });
      if (res?.data?.data) {
        const mapped = res.data.data.map((img: any) => ({
          fileUrl: img.wash_image_path,
          id: img.id,
        }));
        setExistingImages(mapped);
      }
    } catch {
      setExistingImages([]);
    }
  };

  const uploadHandler = useCallback(
    async (file: File) => {
      const base64 = await fileToBase64(file);
      await request.post("/api/uploadWashImage", {
        washId,
        image: base64,
      });
    },
    [washId],
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2, pr: 6 }}>
        Wash Images
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <MultiImageUpload
          apiUrl="/api/uploadWashImage"
          payload={{ washId }}
          existingImages={existingImages}
          onUploadSuccess={fetchImages}
          uploadHandler={uploadHandler}
        />
      </DialogContent>
    </Dialog>
  );
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
